import styled from "@emotion/styled";
import { Chip } from "@mui/material";

const LabelContainer = styled.div`
  flex-basis: 100%;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    flex-basis: 50%;
  }
`;

const DateContainer = styled.div`
  display: flex;
  flex-basis: 100%;
  justify-content: flex-start;
  order: 3;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    flex-basis: 50%;
    justify-content: flex-end;
    order: 2;
  }
`;

const Label = styled(Chip)`
  width: max-content;
  font-size: 14px;
  font-weight: 600;
  padding: 5px ${p => p.theme.space[4]}px;
  border-radius: ${({ theme }) => theme.radii.label};

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    font-size: 16px;
    padding: 6px ${p => p.theme.space[5]}px;
  }
`;

const Date = styled(Chip)`
  width: max-content;
  font-size: 14px;
  font-weight: 500;
  padding: ${p => p.theme.space[2]}px ${p => p.theme.space[4]}px
    ${p => p.theme.space[2]}px ${p => p.theme.space[3]}px;
  border-radius: ${({ theme }) => theme.radii.label};
  color: ${({ theme }) => theme.colors.secondary.gray};

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    font-size: 16px;
    padding: 6px ${p => p.theme.space[3]}px;
  }

  svg {
    width: 20px;
    height: 20px;
    color: ${({ theme }) => theme.colors.black};
  }

  .MuiChip-icon {
    color: ${({ theme }) => theme.colors.black};
    margin-right: 6px;
  }
`;

const Title = styled.h1`
  margin-top: ${p => p.theme.space[4]}px;
  margin-bottom: ${p => p.theme.space[4]}px;
  order: 2;

  font-size: 26px;
  font-weight: 600;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    font-size: 42px;
    font-weight: 700;
    margin-bottom: 0;
    order: 3;
  }
`;

export { LabelContainer, DateContainer, Label, Date, Title };
